module.exports = __webpack_public_path__ + "media/Cree-morning-song-A.d2181dfa.mp3";